import { createApp } from 'vue'
import Repeater from './Repeater.vue'
import FileInput from './FileInput.vue'
import ToothChartInput from './ToothChartInput.vue'
import Toast, { useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";

const app = createApp({})
app.use(Toast);
app.component('repeater', Repeater);
app.component('fileInput', FileInput);
app.component('toothChartInput', ToothChartInput);

// Export the toast function for components that need it
export const showToast = function(message, type = 'success') {
    const toast = useToast();
    toast[type](message);
}

export default app;
